import api from '@/services/utils/base';

export default class CustomMarks {
  post(data:any) {
    return api.post('/custom-columns', data)
      .then((res: any) => Promise.resolve(res.data.payload))
  }

  get() {
    return api.get('/custom-columns')
      .then((res: any) => Promise.resolve(res.data.payload));
  }

  delete(id: string) {
    return api.delete(`custom-columns/${id}`);
  }


  put(data:any) {
    return api.put(`/custom-columns/${data.id}`, data)
        .then((res: any) => Promise.resolve(res.data.payload));
  }
}
